import { FareConditionsResponse } from 'src/sdk-servicing';
import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib/store';
import { GetFareConditionsModel } from './get-fare-conditions.state';

/** StateDetailsActions */
const ACTION_SET = '[GetFareConditions] set';
const ACTION_UPDATE = '[GetFareConditions] update';
const ACTION_RESET = '[GetFareConditions] reset';
const ACTION_FAIL = '[GetFareConditions] fail';
const ACTION_CANCEL_REQUEST = '[GetFareConditions] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[GetFareConditions] set from api';
const ACTION_UPDATE_FROM_API = '[GetFareConditions] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setGetFareConditions = createAction(ACTION_SET, props<WithRequestId<GetFareConditionsModel>>());

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateGetFareConditions = createAction(
  ACTION_UPDATE,
  props<WithRequestId<Partial<GetFareConditionsModel>>>()
);

/**
 * Clear the whole state, return to the initial one
 */
export const resetGetFareConditions = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelGetFareConditionsRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failGetFareConditions = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setGetFareConditionsFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<FareConditionsResponse>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateGetFareConditionsFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<FareConditionsResponse>>()
);
